import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import colors from 'vuetify/lib/util/colors'

Vue.use(Vuetify);

const vuetify = new Vuetify({
  theme: {
    dark: true,
    themes: {
      dark: {
        secondary: '#b0bec5',
        accent: '#8c9eff',
        error: colors.red,
        background: '#282828',
        lightGrayBar: colors.blueGrey.lighten5,
        fanhiveHoney: '#ffb300'
      }
    }
  }
})

export default vuetify;
